import React from 'react';
import Button from 'components/buttons/Button';
import useUser from 'hooks/useUser';

const EmailVerifiedPage = () => {
    const { user } = useUser();
    return (
        <div className="container mx-auto max-w-xl pt-12 pb-24 text-center">
            <div className="flex gap-12 flex-col md:flex-row">
                <div className="content flex flex-col items-center">
                    <h2 className="mb-6">Tvoj email je bil uspešno potrjen </h2>
                    {user && <Button link={'/profil'}>Nadaljuj na svoj profil</Button>}
                    {!user && <Button link={'/prijava'}>Prijavi se</Button>}
                    <Button link={'/'} variant={'outlined'} color={'secondary'} styles={'mt-4 max-w-xs'}>
                        Na domačo stran{' '}
                    </Button>
                </div>
                <div className="image">
                    <img src={'/images/verified_illustration.svg'} width={'400px'} />
                </div>
            </div>
        </div>
    );
};

export default EmailVerifiedPage;
